export default "__VITE_ASSET__DC4vA2yv__"